import React from 'react';
import { Grid } from '@material-ui/core';
// import { urls } from '@auteco/constants';
import Card from 'src/components/sharedComponents/Card/Card';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import { useStyles } from './styles';

const EmptyMessage = (props) => {
  const { title, subTitle } = props;
  const classes = useStyles();
  return (
    <>
      <Grid justifyContent="center" container>
        <Grid item xs={6}>
          <Card className={classes.emptyContainer}>
            <CardHeader color="customAuteco">
              <h3>{title}</h3>
              <p>{subTitle}</p>
            </CardHeader>
            {/* <CardMedia className={classes.image} component="img" height="400" width="400" image={randomImg} /> */}

            {/* <ImgWrapper>
              <Img id="alt" src={urls.DEFAULT_IMG} />
            </ImgWrapper> */}
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default EmptyMessage;
